import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../../Util/axios_core_helper";

// EventTips Component
const GraduationEventTips = ({ id }) => {
  const [tipsList, setTipsList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [tipsImageList, setTipsImageList] = useState([]);
  const [modalContent, setModalContent] = useState("");
  const visibleLimit = 5; // Show only 5 tips initially

  // Fetch Event Tips Data
  const fetchData = async () => {
    try {
      const response = await corefetch(
        `EventTips/GetEventTipsDetailsById?displayedInId=${id}`
      );
      if (response && response.length > 0) {
        const sortedTips = response.sort((a, b) => a.sortOrder - b.sortOrder);
        setTipsList(sortedTips);
      } else {
        setTipsList([]);
        console.log("No event tips found");
      }
    } catch (error) {
      console.error("Error fetching event tips:", error);
      setTipsList([]);
    }
  };

  const fetchEventTipsImageData = async () => {
    try {
      const response = await corefetch(
        `EventTips/GetEventTipsImageDetailsById?displayedInId=${id}`
      );
      if (response && response.length > 0) {
        console.log("fxftyxfyt:", response);
        setTipsImageList(response);
      } else {
        setTipsImageList([]);
        console.log("No event tips found");
      }
    } catch (error) {
      console.error("Error fetching event tips:", error);
      setTipsImageList([]);
    }
  };
  // Fetch data on component mount
  useEffect(() => {
    fetchData();
    fetchEventTipsImageData();
  }, [id]);

  const handleOpenModal = () => {
    const numberedPointContent = `
      <ol>
        ${tipsList
          .map((tip) => `<li><b>${tip.title}:</b> ${tip.description}</li>`)
          .join("")}
      </ol>
    `;
    setModalContent(numberedPointContent);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Determine if the Read More button should be shown
  const shouldShowReadMore = tipsList.length > visibleLimit;

  const visibleTips = tipsList.slice(0, visibleLimit); // Show only the first 5 tips

  if (!tipsList || tipsList.length === 0) {
    return null;
  }

  return (
    <>
      {/* Render the event tips section */}
      <section className="wpo-contact-section-s4 section-padding wedding-background">
        <div className="container">
          <div className="row align-items-center">
            <div className="col col-lg-3 col-md-4 col-12">
              {tipsImageList.length > 0 && (
                <div
                  className="contact-img"
                  key={tipsImageList[0].eventTipsImageId}
                >
                  <img
                    src={`${ImageURL}${tipsImageList[0].leftImagePath}`}
                    alt={tipsImageList[0].displayedInName}
                    className="img-fluid"
                    style={{
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}
            </div>
            <div className="col col-lg-6 col-md-8 col-12">
              <div className="wpo-contact-section-wrapper">
                <div className="wpo-contact-form-area">
                  <div className="wpo-section-title">
                    <h4>Graduation Planning Ideas</h4>
                  </div>
                  <ol className="wedding-tips-list">
                    {visibleTips?.map((tip) => (
                      <li key={tip.eventTipsID}>
                        <b>{tip.title}:</b> {tip.description}
                      </li>
                    ))}
                  </ol>
                  <div
                    className="submit-area"
                    style={{
                      justifyContent: shouldShowReadMore
                        ? "flex-start"
                        : "center",
                    }}
                  >
                    {/* Contact Us Button */}
                    <a href="/ContactUs" className="theme-btn">
                      Contact Us
                    </a>

                    {/* Conditionally render Read More */}
                    {shouldShowReadMore && (
                      <button
                        className="theme-btn read-more-btn"
                        onClick={handleOpenModal}
                        style={{ marginLeft: "5px" }}
                      >
                        Read More
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col col-lg-3 col-md-4 col-12">
              {tipsImageList.length > 0 && (
                <div
                  className="contact-img"
                  key={tipsImageList[0].eventTipsImageId}
                >
                  <img
                    src={`${ImageURL}${tipsImageList[0].rightImagePath}`}
                    alt={tipsImageList[0].displayedInName}
                    className="img-fluid"
                    style={{
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Modal for Read More */}
      {showModal && (
        <div
          className="popup"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)", // Optional: To dim the background
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="modal-content packages"
            style={{
              maxWidth: "600px", // You can adjust this width as per your design
              maxHeight: "80vh", // Set max height to 80% of the viewport height
              overflow: "auto", // Enable scrolling when content overflows
              backgroundColor: "white",
              padding: "20px",
              position: "relative",
            }}
          >
            <span
              className="close"
              onClick={handleCloseModal}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
            >
              &times;
            </span>
            <div
              className="modal-header"
              style={{
                fontSize: "1.25rem",
                fontWeight: "bold",
                marginBottom: "15px",
              }}
            >
              Event Tips Details
            </div>
            <div
              className="additional-text"
              style={{
                maxHeight: "60vh", // You can adjust the height as needed
                overflowY: "auto", // Enable vertical scrolling if content overflows
              }}
              dangerouslySetInnerHTML={{ __html: modalContent }}
            ></div>
          </div>
        </div>
      )}
    </>
  );
};

export default GraduationEventTips;
